import React from 'react';
import 'whatwg-fetch';
import ReactDOM from 'react-dom';
import App from './CMI5App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'mobx-react';
import stores from './stores';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();
ReactDOM.render(
    // <Sentry.ErrorBoundary fallback={"An error has occurred"}>

    <Provider {...stores}>
        <Router history={history}>
            <App />
        </Router>
    </Provider>,
    //   </Sentry.ErrorBoundary>
    document.getElementById('root')
);
serviceWorker.unregister();
